import React from "react";
import { Route, Switch, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import Header from "../components/Header/index";
import Sidebar from "containers/SideNav/index";
import Footer from "components/Footer";
import Tour from "../components/Tour/index";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import {
  hideMessage,
  showAuthLoader,
  userSignIn,
  getCurrentUser,
} from "actions/Auth";
import {
  ABOVE_THE_HEADER,
  BELOW_THE_HEADER,
  COLLAPSED_DRAWER,
  FIXED_DRAWER,
  HORIZONTAL_NAVIGATION,
} from "constants/ActionTypes";
import { isIOS, isMobile } from "react-device-detect";
import asyncComponent from "../util/asyncComponent";
import TopNav from "../components/TopNav";

class App extends React.Component {
  componentDidUpdate() {
    if (this.props.showMessage) {
      setTimeout(() => {
        this.props.hideMessage();
      }, 100);
    }
  }

  render() {
    const {
      match,
      drawerType,
      navigationStyle,
      horizontalNavPosition,
      showMessage,
      alertMessage,
    } = this.props;
    const drawerStyle = drawerType.includes(FIXED_DRAWER)
      ? "fixed-drawer"
      : drawerType.includes(COLLAPSED_DRAWER)
      ? "collapsible-drawer"
      : "mini-drawer";

    //set default height and overflow for iOS mobile Safari 10+ support.
    if (isIOS && isMobile) {
      document.body.classList.add("ios-mobile-view-height");
    } else if (document.body.classList.contains("ios-mobile-view-height")) {
      document.body.classList.remove("ios-mobile-view-height");
    }

    return (
      <div className={`app-container ${drawerStyle}`}>
        {/* <Tour/> */}

        <Sidebar />
        <div className="app-main-container">
          <div
            className={`app-header ${
              navigationStyle === HORIZONTAL_NAVIGATION
                ? "app-header-horizontal"
                : ""
            }`}
          >
            {navigationStyle === HORIZONTAL_NAVIGATION &&
              horizontalNavPosition === ABOVE_THE_HEADER && (
                <TopNav styleName="app-top-header" />
              )}
            <Header />
            {navigationStyle === HORIZONTAL_NAVIGATION &&
              horizontalNavPosition === BELOW_THE_HEADER && <TopNav />}
          </div>

          <main className="app-main-content-wrapper">
            <div className="app-main-content">
              <Switch>
                <Route
                  path={`${match.url}/home`}
                  component={asyncComponent(() => import("./routes/dashboard"))}
                />
                <Route
                  path={`${match.url}/users`}
                  component={asyncComponent(() => import("./routes/users"))}
                />
                <Route
                  path={`${match.url}/plans`}
                  component={asyncComponent(() => import("./routes/plans"))}
                />

                <Route
                  path={`${match.url}/AppSumo`}
                  component={asyncComponent(() => import("./routes/AppSumo/index"))}
                />
                <Route
                  path={`${match.url}/appsumo`}
                  component={asyncComponent(() => import("./routes/AppSumo/index"))}
                />
                <Route
                  path={`${match.url}/partner-coupons`}
                  component={asyncComponent(() => import("./routes/AppSumo/index"))}
                />
                <Route
                  path={`${match.url}/partnercoupons`}
                  component={asyncComponent(() => import("./routes/AppSumo/index"))}
                />

                <Route
                  path={`${match.url}/templates`}
                  component={asyncComponent(() => import("./routes/templates"))}
                />
                <Route
                  path={`${match.url}/workspace`}
                  component={asyncComponent(() => import("./routes/workspace"))}
                />
                <Route
                  path={`${match.url}/interfaces`}
                  component={asyncComponent(() => import("./routes/interfaces"))}
                />
                <Route
                  path={`${match.url}/stack`}
                  component={asyncComponent(() => import("./routes/stack"))}
                />
                <Route
                  path={`${match.url}/file-migration`}
                  component={asyncComponent(() => import("./routes/fileMigration"))}
                />
                <Route
                  path={`${match.url}/platform-usage`}
                  component={asyncComponent(() => import("./routes/platformUsage"))}
                />
                <Route
                  path={`${match.url}/platformusage`}
                  component={asyncComponent(() => import("./routes/platformUsage"))}
                />
                <Route
                  path={`${match.url}/campaign/workspace`}
                  component={asyncComponent(() => import("./routes/campaignWorkspace"))}
                />
                <Route
                  path={`${match.url}/manageusers`}
                  component={asyncComponent(() =>
                    import("./routes/usersmngt/basic")
                  )}
                />
                <Route
                  path={`${match.url}/maker-community`}
                  component={asyncComponent(() =>
                    import("./routes/makercommunity/index")
                  )}
                />
                <Route
                  path={`${match.url}/manageaes`}
                  component={asyncComponent(() =>
                    import("./routes/sesapi/basic")
                  )}
                />
                <Route
                  path={`${match.url}/inapp`}
                  component={asyncComponent(() =>
                    import("./routes/inappnotification/basic")
                  )}
                />
                <Route
                  path={`${match.url}/userinfo`}
                  component={asyncComponent(() => import("./routes/userinfo"))}
                />
                <Route
                  path={`${match.url}/apps`}
                  component={asyncComponent(() => import("./routes/apps"))}
                />
                <Route
                  path={`${match.url}/controls`}
                  component={asyncComponent(() => import("./routes/controls"))}
                />
                <Route
                  path={`${match.url}/help`}
                  component={asyncComponent(() => import("./routes/help"))}
                />
                <Route
                  path={`${match.url}/creator`}
                  component={asyncComponent(() => import("./routes/creator"))}
                />
                <Route
                  path={`${match.url}/collections`}
                  component={asyncComponent(() => import("./routes/collections"))}
                />
                 <Route
                  path={`${match.url}/signupusers`}
                  component={asyncComponent(() => import("./routes/SignupUsers"))}
                />
                <Route
                  component={asyncComponent(() =>
                    import("components/Error404")
                  )}
                />
              </Switch>
            </div>
            {/* <Footer/> */}
            {/*showMessage && NotificationManager.error("Error") <NotificationContainer />*/}
          </main>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ settings, auth }) => {
  const { loader, alertMessage, showMessage, authUser } = auth;
  const { drawerType, navigationStyle, horizontalNavPosition } = settings;
  return {
    drawerType,
    navigationStyle,
    horizontalNavPosition,
    alertMessage,
    showMessage,
  };
};
export default withRouter(connect(mapStateToProps, { hideMessage })(App));
